import { useParams, Link, Navigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { getPost, posts } from "@/data/blog";
import { RevealBlock } from "@/components/Reveal";

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPost(slug);
  if (!post) return <Navigate to="/journal" replace />;

  const others = posts.filter((p) => p.slug !== slug).slice(0, 3);

  return (
    <>
      <SEO
        title={post.title}
        description={post.excerpt}
        path={`/journal/${post.slug}`}
        image={post.hero}
        type="article"
      />
      <article className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 md:pt-20 pb-24">
        <Link
          to="/journal"
          className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#111111]/60 hover:text-[#C17A43]"
        >
          ← Back to Journal
        </Link>

        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mt-16 mb-6">
          {post.category} · {post.date} · {post.readTime}
        </p>
        <RevealBlock>
          <h1 className="font-serif text-[clamp(2.5rem,7vw,8rem)] leading-[0.9] tracking-tighter text-[#111111] max-w-[20ch]">
            {post.title}
          </h1>
        </RevealBlock>

        <div className="relative aspect-[21/9] my-16 border border-[#D9D6D0] overflow-hidden">
          <img
            src={post.hero}
            alt={post.title}
            className="absolute inset-0 w-full h-full object-cover grayscale contrast-110"
          />
        </div>

        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] sticky top-32">
              — Article
            </p>
          </div>
          <div className="col-span-12 lg:col-span-8">
            <RevealBlock>
              <p className="font-serif italic text-3xl md:text-5xl leading-tight text-[#111111] mb-12">
                {post.excerpt}
              </p>
            </RevealBlock>
            {post.body.map((p, i) => (
              <RevealBlock key={i} delay={i * 0.06}>
                <p className="font-sans text-base md:text-lg leading-relaxed text-[#111111]/80 mb-6">
                  {p}
                </p>
              </RevealBlock>
            ))}
          </div>
        </div>

        <div className="border-t border-[#D9D6D0] mt-24 pt-16">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-8">
            — Continue Reading
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#D9D6D0] border border-[#D9D6D0]">
            {others.map((o) => (
              <Link
                key={o.slug}
                to={`/journal/${o.slug}`}
                className="group bg-[#F5F3EF] p-8 hover:bg-[#111111] hover:text-[#F5F3EF] transition-colors duration-500 flex flex-col justify-between min-h-[220px]"
              >
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] opacity-60">
                  {o.category}
                </p>
                <h3 className="font-serif text-xl md:text-2xl leading-tight group-hover:italic transition-[font-style] duration-300">
                  {o.title}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </article>
    </>
  );
}
